// extracted by mini-css-extract-plugin
export default {"svg_frame":"Loading_svg_frame__4nkhs","PreImg":"Loading_PreImg__EF1Fs","PreTag":"Loading_PreTag__D7H1P"};